import type { CSSProperties } from "react";

import { useI18nContext } from "@hopper-b2b/i18n";
import { Spinner } from "@hopper-b2b/ui";

const REDIRECT_LOADER_STYLE: CSSProperties = {
  position: "fixed",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "var(--background-default)",
};

const VISUALLY_HIDDEN_STYLE: CSSProperties = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
};

/**
 * Full-screen spinner shown while a commerce-platform rollout decision is
 * pending or a redirect to commerce-portals is in flight, so the legacy
 * screen never flashes first. Used by `FlightSearchRoute` (search entry)
 * and `TripRoute` (flight trip details, NU-403).
 */
export const RedirectLoader = () => {
  const { t } = useI18nContext();

  return (
    <div style={REDIRECT_LOADER_STYLE} role="status" aria-live="polite">
      <Spinner />
      <span style={VISUALLY_HIDDEN_STYLE}>{t("loading")}</span>
    </div>
  );
};

export default RedirectLoader;
